/* eslint-disable */
<template>
  <div class="settings">
    <AdminNavigation ref="navigation" indexProps="9" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Add / Edit Person Conditions</h1></div>
        <div class="header-sub-title">The set of conditions shown below are used in the following places: Booking - Person Conditions, Specialist - Expert in, and Specialists - Special Interests.</div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="11" />
      <div class="content">
        <div class="content-scroll-x">
          <div>
            <div>
              <table class="table">
                <thead>
                  <tr>
                    <th style="width:42.5%" class="long-text">Id</th>
                    <th style="width:42.5%" class="long-text">Name</th>
                    <th style="width:15%; vertical-align:middle" class="icon-col">
                      <div class="icon-group justify-content-center align-items-center"><v-btn class="add-icon" dark @click="addNewPersonCondition">Add New</v-btn></div>
                      <AddPersonConditionModal ref="addPersonConditionModal" />
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <!-- <div :class="specialists.length > 5 ? 'content-scroll-y' : ''"> -->
            <div>
              <table class="table">
                <tbody>
                  <template v-for="(condition, index) in personConditions">
                    <tr :key="index">
                    <td style="width:42.5%" class="long-text">
                      {{condition.PersonConditionID}}
                    </td>
                    <td style="width:42.5%" class="long-text">
                      {{decodeURIComponent(condition.ConditionName)}}
                    </td>
                    <td style="width:15%;vertical-align:middle" class="icon-col">
                      <div class="icon-group justify-content-center align-items-center" style="height:100%">
                        <img @click="editCondition(condition)"  src="@/assets/images/edit_icon.svg" />
                      </div>
                    </td>
                    </tr>
                    <tr v-if="hasError && relatedSkill.hasError" class="text-danger" :key="indexOuter+500"><td colspan="3">This relationship already exists. Please ensure there are no duplicates and try again.</td></tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import AdminNavigation from '@/components/AdminNavigation'
  import AdminSettingsMenu from '@/components/AdminSettingsMenu'
  import AddPersonConditionModal from '@/components/AddPersonConditionModal'
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'

  export default {
    name: 'AdminSettings',
    components: {
      AdminNavigation,
      AdminSettingsMenu,
      AddPersonConditionModal,
      Header,
    },
    data() {
      return {
        hasError: false,
        personConditions: [],

        successMessage: '',
      }
    },
    computed: {},
    methods: {
      async loadData() {
        this.personConditions = await utilities.getPersonConditions()
        console.log(this.personConditions)
      },

      addNewPersonCondition() {
        this.$refs.addPersonConditionModal.isEdit = false
        this.$refs.addPersonConditionModal.handleModal()
      },

      editCondition(item) {
        this.$refs.addPersonConditionModal.isEdit = true
        this.$refs.addPersonConditionModal.editItem(item)
        this.$refs.addPersonConditionModal.handleModal()

      }
    },
    async beforeMount() {
      this.$store.dispatch("loading/setLoadComponent", true)
      await this.loadData()
      this.$store.dispatch("loading/setLoadComponent", false)
    },
    mounted() {},
  }
</script>
